import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

const iconMap: Record<string, string> = {
  剧情: 'ri-book-2-line',
  爱情: 'ri-heart-3-line',
  悬疑: 'ri-eye-line',
  家庭: 'ri-home-heart-line',
  都市: 'ri-building-2-line',
  犯罪: 'ri-police-car-line',
  科幻: 'ri-planet-line',
  惊悚: 'ri-alarm-warning-line',
};

const descMap: Record<string, string> = {
  剧情: '好故事，慢慢讲',
  爱情: '心动与告别',
  悬疑: '真相层层揭开',
  家庭: '屋檐下的温情',
  都市: '城市里的普通人',
  犯罪: '追凶与抉择',
  科幻: '如果时间重来',
  惊悚: '屏住呼吸',
};

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-900">
      <div className="flex items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs font-display tracking-[0.3em] text-accent-400">GENRES</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-black text-foreground-50">
            按类型探索
          </h2>
          <p className="mt-2 text-sm text-foreground-400">从剧情到悬疑，总有一部适合今晚的你</p>
        </div>
        <Link
          to="/movie-category"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          全部影片
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3 md:gap-4">
        {movieCategories.map((category) => (
          <Link
            key={category}
            to={`/movie-category?type=${encodeURIComponent(category)}`}
            className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-lg bg-background-800/60 border border-background-700/70 hover:border-primary-500/60 hover:bg-background-800 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 md:w-12 md:h-12 shrink-0 rounded-md bg-primary-500/12 text-primary-400 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${iconMap[category]} text-xl md:text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block text-sm md:text-base font-semibold text-foreground-100">{category}</span>
              <span className="block text-xs text-foreground-400 truncate">{descMap[category]}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}